import { AlertCircle } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/shared/utils/cn';

import { Button } from '../actions/Button';

export interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
  iconSlot?: ReactNode;
}

export function ErrorState({ title, message, onRetry, className, iconSlot }: ErrorStateProps) {
  const { t } = useTranslation('common');
  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-3 rounded-lg border border-border bg-surface px-6 py-12 text-center',
        className,
      )}
      role="alert"
    >
      {iconSlot ?? <AlertCircle className="h-10 w-10 text-danger" aria-hidden="true" />}
      <div className="text-sm font-semibold text-fg">
        {title ?? t('ui.errorState.defaultTitle')}
      </div>
      {message ? <div className="max-w-sm text-sm text-fg-muted">{message}</div> : null}
      {onRetry ? (
        <Button type="button" variant="secondary" onClick={onRetry}>
          {t('actions.retry')}
        </Button>
      ) : null}
    </div>
  );
}
